/**
 * appSignOperationBtnsModule
 * description: app渠道下操作按钮
 * author: Qian.qianchen 2019-03-26
 */
'use strict';
angular.module('allMediaSignBtnsModule', []).directive('allMediaSignBtns', ['modalDialog', 'trsHttpService', 'sensitiveWordCheckService', 'newMediaService', 'editingCenterService', 'trsspliceString', '$state',
    function (modalDialog, trsHttpService, sensitiveWordCheckService, newMediaService, editingCenterService, trsspliceString, $state) {
        return {
            restrict: 'E',
            replace: false,
            templateUrl: './editingCenter/iWo/fusionSign/directive/allMediaSignBtns/allMediaSignBtns.html',
            scope: {
                selectedArr: '=',
                callback: '&',
                isPending: '='
            },
            link: function ($scope, iElement, attrs) {
                initStatus();

                /**
                 * [initStatus description]初始化
                 * @return {[type]}      [description]
                 */
                function initStatus() {
                    $scope.status = {
                        signedSuccess: false,
                        // eslint-disable-next-line no-unneeded-ternary
                        isFusionPending: $state.current.name.split('.')[3] === 'fusionPending' ? true : false,
                    };
                    $scope.newOperationParams = {
                        serviceid: 'mlf_fusion',
                        methodname: 'doActionOnMediaTypeAndDocIdsSync',
                        oprType: 'daishen',
                        actionKey: '',
                        // mediaTypeDocIds: [],
                        // OprTime: $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                        // OprTimeStart: '',
                        // OprTimeEnd: '',
                    };
                    $scope.data = {
                        trench: 'Fusion',
                    };
                    $scope.requestData = $scope.callback;
                }

                /**
                 * [dealOperParams description]处理参数
                 * @return  {[type]}   [return description]
                 */
                function dealOperParams() {
                    $scope.newOperationParams.mediaTypeDocIds = [];
                    $scope.selectedArr.forEach((item) => {
                        $scope.newOperationParams.mediaTypeDocIds.push({
                            MEDIATYPE: item.MEDIATYPE,
                            DOCID: item.METADATAID
                        });
                    });
                    $scope.newOperationParams.mediaTypeDocIds = JSON.stringify($scope.newOperationParams.mediaTypeDocIds);
                }

                /**
                 * [revoke description]撤稿
                 * @return {[type]} [description]
                 */
                $scope.revoke = function () {
                    modalDialog.inputModel('撤稿', '撤稿原因（选填）', function (content) {
                        rejection(content);
                    });
                };

                /**
                 * [directSigned description]直接签发
                 * @return {[type]}      [description]
                 */
                $scope.directSigned = function () {
                    modalDialog.confirmModal('签发', '确认发布稿件', function () {
                        sign();
                    });
                };

                /**
                 * [sign description]稿件直接签发app
                 * @return {[type]}      [description]
                 */
                function sign() {
                    dealOperParams();
                    $scope.newOperationParams.oprType = $scope.isPending === true ? 'daibian' : 'daishen';
                    $scope.newOperationParams.actionKey = 'qianfa';
                    // $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.newOperationParams, 'get').then((data) => {

                    // });
                    // var params = {
                    //     serviceid: 'mlf_appoper',
                    //     methodname: 'appDaiShenPublish',
                    //     ObjectIds: trsspliceString.spliceString(array, 'CHNLDOCID', ','),
                    //     ChnlDocIds: trsspliceString.spliceString(array, 'CHNLDOCID', ','),
                    //     MetaDataIds: trsspliceString.spliceString(array, 'METADATAID', ','),
                    // };
                    $scope.$parent.$parent.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.newOperationParams, 'get').then(function (data) {
                        if (data.ISSUCCESS === 'true') {
                            modalDialog.alertType('直接签发成功', '', 'success', false, function () {
                                $scope.callback();
                            });
                        }
                    }, function () {
                        $scope.callback();
                    });
                }

                /**
                 * [timeSinged description]稿件定时签发
                 * @param  {[obj]} item [description]稿件具体信息
                 * @return {[type]}      [description]
                 */
                $scope.timeSinged = function (item) {
                    sensitiveWordCheckService.SensitiveWordsAndCarefulTiming($scope.selectedArr, '').then(function () { }, function () {
                        timeSingedDraft(item);
                    });
                };

                /**
                 * [timeSingedDraft description]定时签发函数
                 * @param  {[obj]} item [description]稿件具体信息
                 * @return {[type]}      [description]
                 */
                function timeSingedDraft(item) {
                    $scope.newOperationParams.oprType = $scope.isPending === true ? 'daibian' : 'daishen';
                    dealOperParams();
                    $scope.newOperationParams.actionKey = 'dingshiqianfa';
                    $scope.newOperationParams.selectedArray = $scope.selectedArr;
                    $scope.$parent.$parent.loadingPromise = editingCenterService.draftTimeSinged($scope.newOperationParams).then(function (data) {
                        $scope.$parent.$parent.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), data, 'post').then(function() {
                            modalDialog.alertType('定时签发成功', '', 'success', false, function () {
                                $scope.callback();
                            });
                        }, function () {
                            $scope.callback();
                        });
                    });
                }

                /**
                 * [lookSigned 审看签发]
                 * @return {[type]} [description]
                 */
                $scope.lookSigned = function () {
                    var queryTitleContent = true;
                    var queryShenKanQianFa = trsspliceString.spliceString($scope.selectedArr, 'CLIENTEXAMINE', ',');
                    var ChnlDocIds = trsspliceString.spliceString($scope.selectedArr, 'CHNLDOCID', ',');
                    if (queryShenKanQianFa.indexOf('1') == -1) {
                        modalDialog.alertType('未同意签发的稿件不允许审看签发', '', 'error', false, function () { });
                        return;
                    }
                    // 如果稿件全部带审看权限,直接签发,不填写提示内容
                    if (queryShenKanQianFa.indexOf('0') == -1) {
                        queryTitleContent = false;
                    }
                    sensitiveWordCheckService.SensitiveWordsAndCareful($scope.selectedArr, '', 1, queryTitleContent).then(function () {
                        $scope.status.signedSuccess = true;
                        lookatSigned(ChnlDocIds);
                    }, function () {
                        modalDialog.confirmModal('签发', '确认是否签发', function () {
                            lookatSigned(ChnlDocIds);
                        });
                    });
                };

                /**
                 * [lookatSigned description]
                 *
                 * @param   {[type]}  item  [item description]
                 *
                 * @return  {[type]}        [return description]
                 */
                function lookatSigned(item) {
                    var params = {
                        'serviceid': 'mlf_appoper',
                        'methodname': 'appDaiShenKanShenPublish',
                        'ChnlDocIds': item
                    };
                    $scope.$parent.$parent.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        if ($scope.status.signedSuccess) {
                            modalDialog.multiReportsAlert(data, '');
                            $scope.callback();
                        } else {
                            modalDialog.alertType('审看签发成功', '', 'success', false, function () {
                                $scope.callback();
                            });
                        }
                        $scope.status.signedSuccess = false;
                    }, function () {
                        $scope.callback();
                        $scope.status.signedSuccess = false;
                    });
                }

                /**
                * [rejection description]
                *
                * @param   {[type]}  content  [content description]
                *
                * @return  {[type]}           [return description]
                */
                function rejection(content) {
                    $scope.newOperationParams.oprType = 'daishen';
                    $scope.newOperationParams.actionKey = 'tuigao';
                    dealOperParams();
                    // var params = {
                    //     serviceid: 'mlf_appoper',
                    //     methodname: 'rejectionMetaDatas',
                    //     ChnlDocIds: trsspliceString.spliceString($scope.selectedArr, 'CHNLDOCID', ','),
                    //     MetaDataIds: trsspliceString.spliceString($scope.selectedArr, 'METADATAID', ','),
                    //     Opinion: content,
                    //     ChannelId: $scope.selectedArr[0].CHANNELID
                    // };
                    $scope.$parent.$parent.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.newOperationParams, 'get').then(function (data) {
                        if (data.ISSUCCESS === 'true') {
                            modalDialog.alertType('撤稿成功', '', 'success', false, function () {
                                $scope.callback();
                            });
                        }

                    }, function () {
                        $scope.callback();
                    });
                }

                /**
                 * [checkSecondReview description] 判断所选稿件中是否带有二次审核的稿件
                 * @return {[type]} [description]
                 */
                function checkSecondReview() {
                    var secondReview = false;
                    angular.forEach($scope.selectedArr, function (data, index) {
                        if (angular.isDefined(data.ISSECONDREVIEW) && data.ISSECONDREVIEW == '1') {
                            secondReview = true;
                        }
                    });
                    return secondReview;
                }
                $scope.trill = function () {
                    $scope.newOperationParams.actionKey = 'songshen';
                    $scope.newOperationParams.oprType = 'daibian';
                    $scope.data.selectedArray = $scope.selectedArr;
                    $scope.loadingPromise = newMediaService.trial($scope, $scope.newOperationParams);
                };
            }
        };
    }
]);
